// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2ae2bd38","198":"edbc688b","477":"82525edb","627":"0ab9fc2d","663":"68058f8c","803":"850164a3","820":"10f86967"}[chunkId] + ".chunk.js";
};